import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-inscription-validation',
    templateUrl: './inscription-validation.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./inscription-validation.component.css']
})
export class InscriptionValidationComponent implements OnInit {
  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[]=[]
  data:any[]=[]
  is_active=null
  selected_data:any;
  classroomSelected=null
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="admin-inscription-validations"
  
  constructor(
    private router:Router,
    private sacService:StudentAyClassroomService,
    private classroomService:ClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
    
  ngOnInit(): void {
    this.buttonsPermission={
      show:true,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
   this.getClassrooms()
   
  }

  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active


  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }


  show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/inscription-details/'+this.selected_data.student?.ins.code])
  }

  getAll(){
    this.sacService.getForValidation(this.classroomSelected).subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des réinscriptions",err)
    })
  }
  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des réinscriptions",err)
    })
  }


  loadStudents(ev:any){
    this.classroomSelected=ev.target.value
    this.getAll()
  }
  
  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des réinscriptions",err)

      })
  }
}
